import { z } from "zod";

import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";

export const CreateJobFormSchema = z.object({
  name: z
    .string()
    .min(1, { error: () => getTranslation(Resources.Validation.Required) }),
});

export type CreateJobFormData = z.infer<typeof CreateJobFormSchema>;
